<template>
  <div>
    <CoreDrawer
      :value="isDialogOpened"
      :title="t('Фильтры', options)"
      attach=".vue-the-doctors-filters .v-application"
      @input="closeDialog"
    >
      <template #default>
        <SelectedChips v-model="doctorFiltersState" />
        <RadioGroupAppointment
          v-model="doctorFiltersState"
          class="px-4 my-4"
        />
        <v-divider class="my-4" />
        <v-expand-transition>
          <div v-if="filtersStore.unsavedFilters.visitLocation === 'online'">
            <ListItemCity v-model="doctorFiltersState" />
          </div>
        </v-expand-transition>
        <ListItemSpeciality v-model="doctorFiltersState" />
        <v-expand-transition>
          <div v-if="filtersStore.unsavedFilters.visitLocation === 'clinic'">
            <ListItemDate v-model="doctorFiltersState" />
            <ListItemPlace v-model="doctorFiltersState" />
          </div>
        </v-expand-transition>
        <v-expand-transition>
          <div>
            <v-divider class="my-4" />
            <FieldAge
              v-model="doctorFiltersState"
              class="px-4"
            />
          </div>
        </v-expand-transition>
        <v-expand-transition>
          <div v-if="filtersStore.unsavedFilters.visitLocation !== 'home'">
            <v-divider class="my-4" />
            <FieldPrices
              v-model="doctorFiltersState"
              :is-visible="isDialogOpened"
              class="px-4"
            />
          </div>
        </v-expand-transition>
        <v-expand-transition>
          <div>
            <v-divider class="my-4" />
            <ChipGroupExperience
              v-model="doctorFiltersState"
              class="px-4"
              :class="filtersStore.unsavedFilters.visitLocation === 'clinic' ? 'mb-2' : 'mb-4'"
            />
            <SwitchHighRating
              v-model="doctorFiltersState"
              class="mb-2"
            />
            <ListItemDisease v-model="doctorFiltersState" />
            <ListItemOtherSpeciality v-model="doctorFiltersState" />
            <v-divider class="my-4" />
            <template v-if="filtersStore.unsavedFilters.visitLocation === 'clinic'">
              <SwitchAppointment
                v-model="doctorFiltersState"
                class="mb-2"
              />
              <SwitchClub
                v-if="!isYDoc"
                v-model="doctorFiltersState"
              />
              <v-divider class="my-4" />
            </template>
            <div class="px-4">
              <ChipGroupGender
                v-model="doctorFiltersState"
                class="mb-4"
              />
              <ChipGroupCategory
                v-model="doctorFiltersState"
                class="mb-4"
              />
              <ChipGroupScience
                v-model="doctorFiltersState"
                class="mb-4"
              />
            </div>
            <v-divider class="my-4" />
            <ListItemSort v-model="doctorFiltersState" />
          </div>
        </v-expand-transition>
      </template>
      <template #footer>
        <BtnShowDoctors
          :active="isDialogOpened"
          class="pa-2 elevation-8"
          :trigger-request="triggerUpdateDoctorsCount"
          @click:submit="applyDoctorFilters"
          @click:close="closeDialog()"
        />
      </template>
    </CoreDrawer>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed, ref, watch } from 'vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import FieldAge from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldAge/FieldAge.vue'
import FieldPrices from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/FieldPrices/FieldPrices.vue'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import SelectedChips from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SelectedChips/SelectedChips.vue'
import SwitchClub from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchClub/SwitchClub.vue'
import SwitchAppointment from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchAppointment/SwitchAppointment.vue'
import SwitchHighRating from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchHighRating/SwitchHighRating.vue'
import ListItemCity from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemCity/ListItemCity.vue'
import ListItemSort from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemSort/ListItemSort.vue'
import ListItemDate from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemDate/ListItemDate.vue'
import ListItemPlace from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemPlace/ListItemPlace.vue'
import ListItemDisease from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemDisease/ListItemDisease.vue'
import ListItemSpeciality from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemSpeciality/ListItemSpeciality.vue'
import ListItemOtherSpeciality from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ListItemOtherSpeciality/ListItemOtherSpeciality.vue'
import ChipGroupGender from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupGender/ChipGroupGender.vue'
import ChipGroupScience from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupScience/ChipGroupScience.vue'
import ChipGroupCategory from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupCategory/ChipGroupCategory.vue'
import ChipGroupExperience from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupExperience/ChipGroupExperience.vue'
import RadioGroupAppointment from 'www/vue_components/common/TheFilters/doctors/components/VisitLocationFilters/components/RadioGroupAppointment/RadioGroupAppointment.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const isYDoc = window.IS_YDOC

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('DoctorFilters')

const { t, language } = I18NextVue
const options = { ns: language }

const doctorFiltersState = ref({ ...filtersStore.filters } as Filters)
const resetDoctorFiltersState = () => {
  doctorFiltersState.value = { ...filtersStore.filters }
  filtersStore.resetUnsavedFilters()
}

watch(() => isDialogOpened.value, resetDoctorFiltersState)

const triggerUpdateDoctorsCount = ref(false)
const updateDoctorsCount = () => {
  triggerUpdateDoctorsCount.value = !triggerUpdateDoctorsCount.value
}

watch(doctorFiltersState, updateDoctorsCount, { deep: true })

const hasAppliedFilters = computed(() => Boolean(
  filtersStore.filters.category
  || filtersStore.filters.city
  || filtersStore.filters.disease
  || filtersStore.filters.otherSpeciality
  || filtersStore.filters.isClubAppointment
  || filtersStore.filters.isOnlineAppointment
  || filtersStore.filters.isHighRating
  || filtersStore.filters.experience
  || filtersStore.filters.gender
  || filtersStore.filters.science
  || filtersStore.filters.patientAge
  || filtersStore.filters.dateRange
  || filtersStore.filters.timesOfDay
  || filtersStore.filters.place
  || filtersStore.filters.price.to
  || filtersStore.filters.price.from
  || filtersStore.filters.sort,
))

watch(
  () => hasAppliedFilters.value,
  () => {
    chipsStore.updateMenuChip({
      isActive: hasAppliedFilters.value,
      isVisible: true,
      onClick: openDialog,
    })
  },
  { immediate: true },
)

const applyDoctorFilters = async () => {
  closeDialog()

  if (doctorFiltersState.value.visitLocation === 'home') {
    filtersStore.updateFilters({
      ...doctorFiltersState.value,
      price: {
        from: undefined,
        to: undefined,
      },
      city: undefined,
      dateRange: undefined,
      timesOfDay: undefined,
      place: undefined,
      isOnlineAppointment: undefined,
      isClubAppointment: undefined,
    })
  } else if (doctorFiltersState.value.visitLocation === 'online') {
    filtersStore.updateFilters({
      ...doctorFiltersState.value,
      place: undefined,
      dateRange: undefined,
      timesOfDay: undefined,
      isOnlineAppointment: undefined,
      isClubAppointment: undefined,
    })
  } else {
    filtersStore.updateFilters({
      ...doctorFiltersState.value,
      city: undefined,
    })
  }

  await updateDoctorListPage()
}
</script>
